export const MAX_TAGS_PER_DESIGN = 8;

export function resolveTags(tagIds, designTags) {
  const ids = tagIds || [];
  return designTags.filter(tag => ids.includes(tag.id));
}

export function existingTagIds(tagIds, designTags) {
  return resolveTags(tagIds, designTags).map(tag => tag.id);
}



// WEBPACK FOOTER //
// ./src/utils/designTags.js